import { Button, SvgIcon } from "@mui/material";
import React from "react";
import { icons } from "../utils/icons";

type ClearFormButtonProps = {
    onClick: () => void;
    className?: string;
};

export const ClearFormButton = ({
    onClick,
    className
}: ClearFormButtonProps) => {
    return (
        <Button
            variant="outlined"
            color="shBlack"
            className={`${className}`}
            sx={(theme) => {
                return {
                    "&.MuiButton-root": {
                        borderColor: theme.palette.grey[300],
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                    }
                };
            }}
            onClick={onClick}
        >
            <div className="flex items-center gap-4">
                <span>Reset filters</span>
                <SvgIcon
                    inheritViewBox
                    style={{
                        width: 12,
                        height: 12
                    }}
                    component={icons["clear"][0]}
                    color="primary"
                />
            </div>
        </Button>
    );
};
